<template>
    <div class="users-opinion">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="users-opinion__content">
                        <TitleDescription
                            title="What Our Users Say"
                        />
                        <div class="users-opinion__slider-wrapper">
                            <div class="users-opinion__text-slider-wrapper">
                                <div class="users-opinion__text-slider">
                                    <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                                        <swiper-slide
                                            v-for="(item, index) in sliderInitialData" 
                                            :key="index"
                                            :id="`user-opinion-${index}`"
                                            class="users-opinion__item"
                                        >   
                                            <ReadMore
                                                :text="item.text"
                                                :maxChar="365" 
                                                :maxCharMD="365" 
                                                :maxCharSM="325" 
                                                ref="readMore" 
                                            />
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                            <div class="users-opinion__thumb_slider d-flex justify-content-center">
                                <div class="swiper-button-custom-prev users-opinion__slider-arrows"><Icon icon="landingpage-cards-arrow"/></div>
                                <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                                    <swiper-slide 
                                        v-for="(item, index) in sliderInitialData" 
                                        :key="`thumb-${index}`"
                                        :id="`thumb-${index}`"
                                        class="p-0"
                                        style="cursor: pointer"
                                    >
                                        <div class="users-opinion__user-wrapper">
                                            <img class="users-opinion__user-photo" :src="item.user.photo" alt="">
                                            <div class="users-opinion__user-info">
                                                <TitleDescription
                                                    :title="item.user.name"
                                                    :description="item.user.phraze"
                                                />
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper>
                                <div class="swiper-button-custom-next users-opinion__slider-arrows"><Icon icon="landingpage-cards-arrow"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import TitleDescription from '../../../components/Ecommerce/TitleDescription'
import Icon from '@/components/Theme/Icon'
import { sliderInitialData, swiperOptionTop, swiperOptionThumbs } from './slidersInit'
import ReadMore from '@/components/Ecommerce/ReadMore'
import 'swiper/css/swiper.css'
export default {
    name: 'UsersOpinion',
    components: {
        Icon,
        TitleDescription,
        ReadMore
    },
    data() {
        return {
            sliderInitialData,
            swiperOptionTop,
            swiperOptionThumbs,
            winWidth: null
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    mounted() {
        this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.swiper
            const swiperThumbs = this.$refs.swiperThumbs.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
            swiperTop.on('slideChange', () => {
                this.$refs.readMore.forEach(el => {
                    if(el.expanded) {
                        return el.toggle()
                    }
                    return
                })
            })
        })
        
    },
    
}
</script>
<style lang="scss" scoped>
$background: #F4F7FA;
$users_opinion_content_width: 795px;
$users_opinion_top_gap: 96px;
$users_opinion_bottom_gap: 72px;
$users_opinion_top_gap_mob: 64px;
$users_opinion_bottom_gap_mob: 52px;
$users_opinion_sm_gap: 42px;
$users_opinion_slider_gap: 30px;
$users_opinion_slider_gap_mob: 24px;
$users_opinion_slider_sm_gap: 16px;

.users-opinion {
    --title-fontsize: 28px;
    --title-lineheight: 32px;
    --title-margin-bottom: 0;
    --readmore-font-size: 16px;
    --readmore-line-height: 24px;

    --title-color: #00002D;
    --description-color: #718096;

    @media (max-width: 576px) {
        --readmore-font-size: 14px;
        --readmore-line-height: 20px;   
        --title-fontsize: 20px;
        --title-lineheight: 28px;     
    }

    background: $background;
    padding-top: $users_opinion_top_gap;
    padding-bottom: $users_opinion_bottom_gap;
    @media (max-width: 768px) {
        padding-top: $users_opinion_top_gap_mob;
        padding-bottom: $users_opinion_bottom_gap_mob;
    }
    @media (max-width: 576px) {
        padding-top: $users_opinion_sm_gap;
        padding-bottom: $users_opinion_sm_gap;
    }
    &__user-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &__user-photo {
        width: 56px;
        height: 56px;
        margin-top: 12px;
        border-radius: 50%;
        filter: grayscale(1);
        object-fit: cover;
        @media (max-width: 768px) {
            width: 48px;
            height: 48px;
        }
        @media (max-width: 576px) {
            width: 40px;
            height: 40px;
        }
    }
    &__user-info {
        --title-fontsize: 18px;
        --title-lineheight: 24px;
        --title-margin-bottom: 0;
        --description-fontsize: 14px;
        --description-lineheight: 20px;

        width: 300px;
        text-align: center;
        margin-top: 24px;
        display: none;
        @media (max-width: 576px) {
            margin-top: 12px;
            --title-fontsize: 16px;
            --title-lineheight: 24px;
        }
    }
    &__content {
        width: 100%;
        max-width: $users_opinion_content_width;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &__item {
        text-align: center;
        font-size: 14px !important;
    }
    &__thumb_slider {
        margin-top: 70px;
        @media (max-width: 768px) {
            margin-top: 48px;
        }
        @media (max-width: 576px) {
            margin-top: 28px;
        }
    }
    &__text-slider-wrapper {
        
    }
    &__slider-wrapper {
        width: 100%;
        padding-top: $users_opinion_slider_gap;
        @media (max-width: 768px) {
            padding-top: $users_opinion_slider_gap_mob;
        }
        @media (max-width: 576px) {
            padding-top: $users_opinion_slider_sm_gap;
        }        
    }
    &__text {
        font-size: 16px;
        line-height: 24px;
        @media (max-width: 576px) {
            font-size: 14px;
            line-height: 20px;
        }
    }
    &__text-slider {
        padding-left: 100px;
        padding-right: 100px;
        @media (max-width: 768px) {
            padding-left: 90px;
            padding-right: 90px;
        }
        @media (max-width: 576px) {
            padding-left: 50px;
            padding-right: 50px;
        }
        position: relative;
        &::before,
        &::after {
            content: '';
            position: absolute;
            width: 72px;
            height: 72px;
            background: url('/icons/ecommerce-slider-commas.svg') no-repeat;
            background-size: cover;
            @media (max-width: 768px) {
                width: 64px;
                height: 64px;
            }
            @media (max-width: 576px) {
                width: 40px;
                height: 40px;
            }
        }
        &::before {
            left: 0;
            top: 0;
            transform: translate(0, -20px);
        }
        &::after {
            right: 0;
            bottom: 0;
            transform: rotate(180deg) translate(0, -20px);
        }  

    }
    &__slider-arrows {
        width: 24px;
        height: 24px;
        margin-top: 26px;
        min-width: 24px;
        filter: grayscale(1);
        transform: all 0.1s ease;
        &:hover {
            filter: grayscale(0)
        }
        &:focus {
            outline: 0;
            border: 0;
        }
        &.swiper-button-custom-next {
            img {
                transform: rotate(180deg);  
            }
        }
    }
    .swiper {
        &.gallery-top {
            width: 100%;
            padding-bottom: 0 !important;
        }
        &.gallery-top .swiper-slide {
            display: flex;
            padding: 0 !important;
            background: transparent !important;
        }
        &.gallery-thumbs {
            width: 100%;
            padding-bottom: 0 !important;
            box-sizing: border-box;
            max-width: 350px;
            display: flex;
            align-items: center;
            margin: 0;
            
            @media (max-width: 576px) {
                max-width: 330px;
            }
        }
        &.gallery-thumbs .swiper-slide {
            height: 100%;
            opacity: 0.4;
            background: transparent !important;
        }
        &.gallery-thumbs .swiper-slide-active {
            opacity: 1;
            .users-opinion__user-info {
                display: block;
            }
            .users-opinion__user-photo {
                width: 80px;
                height: 80px;
                margin-top: 0;
                filter: grayscale(0);
                @media (max-width: 768px) {
                    width: 72px;
                    height: 72px;
                }
                @media (max-width: 576px) {
                    width: 64px;
                    height: 64px;
                }
            }
        }
    }
    
}
</style>>
